import { useCallback, useEffect, useMemo } from "react"
import { columnsDetailCollectionTableFilters, columnsDetailCollectionTableHelper } from "../helpers/columnsDetailCollectionTableHelper"
import { changeTableParams, getColumnsFilter } from "@thelpers/customTableHelper"
import { useReceivedPaymentDetailServices } from "../../../../../hooks/useReceivedPaymentDetailServices"
import useRedirectTo from "@thooks/useRedirectTo"
import useCurrentLocation from "@thooks/useCurrentLocation"
import { useReceivedPaymentDetailContext } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/context/ReceivedPaymentDetailContext"
import { useReceivedPaymentDetail } from "./useReceivedPaymentDetail"

export const useReceivedPaymentDetailTable = () => {

    const { handleRedirectTo } = useRedirectTo()
    const { loadingCollectionAdministrationTable, chargeInstanceTableData, setChargeInstanceTableData, getInitialData, setLoadingCollectionAdministrationTable, } = useReceivedPaymentDetailContext()
    const { handleOnOpenCloseModal, isOpenReceivedPaymenteModal } = useReceivedPaymentDetail()
    const { param } = useCurrentLocation()
    const {
        getChargeInstanceDetailService,
    } = useReceivedPaymentDetailServices()


    const serviceParams = useMemo(() => ({
        previousData: chargeInstanceTableData.dataTable,
        actualLimit: chargeInstanceTableData.metadata.limit,
        limit: chargeInstanceTableData.metadata.limit,
        currentPage: chargeInstanceTableData.currentPage,
        skip: 0
    }), [chargeInstanceTableData])


    const handleChangeTable = useCallback(async ({ pagination, filters, sorter }) => {

        const otherParams = {
            charge_instance_id: param?.chargeInstanceId
        }
        const tableParams = changeTableParams({
            serviceParams,
            pagination,
            filters,
            sorter,
            otherParams,
            state: chargeInstanceTableData,
            setState: setChargeInstanceTableData
        })

        if (!tableParams) return

        setLoadingCollectionAdministrationTable(true)
        const { data, metadata } = await getChargeInstanceDetailService({ ...tableParams.finalParams, setLoading: setLoadingCollectionAdministrationTable })
        setChargeInstanceTableData({
            ...chargeInstanceTableData,
            dataTable: data.dataSource,
            metadata: metadata,
            currentPage: tableParams.currentPage,
            currentParams: tableParams.newParams,
            currentFilters: tableParams.actualFilters,

        })
        setLoadingCollectionAdministrationTable(false)
    }, [chargeInstanceTableData,
        param.chargeInstanceId,
        serviceParams,
        setChargeInstanceTableData,
        getChargeInstanceDetailService,
        setLoadingCollectionAdministrationTable
    ])

    const columns = useMemo(() => columnsDetailCollectionTableHelper({
        columns: chargeInstanceTableData.columns,
        chargeInstanceId: param?.chargeInstanceId,
        handleRedirectTo,
        onExonerate: handleOnOpenCloseModal,
        onExtraordinaryPayment: handleOnOpenCloseModal,
        onUpdateAmount: handleOnOpenCloseModal,
        isDelete: chargeInstanceTableData.currentParams?.status === 'deleted'
    }).map((column) => ({
        ...column,
        ...getColumnsFilter(column.dataIndex, columnsDetailCollectionTableFilters({ currentParams: chargeInstanceTableData.currentParams }))
    })), [param?.chargeInstanceId, chargeInstanceTableData, handleRedirectTo, handleOnOpenCloseModal])

    useEffect(() => {
        if (param?.chargeInstanceId) {
            getInitialData({ charge_instance_id: param?.chargeInstanceId })
        }
    }, [param?.chargeInstanceId, getInitialData])

    return {
        loadingCollectionAdministrationTable,
        isOpenReceivedPaymenteModal,
        chargeInstanceTableData,
        columns,
        handleOnOpenCloseModal,
        handleChangeTable
    }
}